import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { productMockupUrl, tomoIncludes, tomos } from '../data/content';
export function TomosSection() {
  return <section id="tomos" className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="tomos-title" data-id="element-273" data-mp="1p4bz608rg8t4">
      <div className="mx-auto max-w-6xl" data-id="element-274" data-mp="xcnrhr0xgagm">
        <div className="grid items-center gap-10 rounded-[2rem] border border-gold/25 bg-surface p-6 sm:p-10 lg:grid-cols-2" data-id="element-275" data-mp="xdpe8srb2le6">
          <div className="text-center lg:text-left" data-id="element-276" data-mp="11g292m4ikyw6">
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-277" data-mp="16cswxvmk8ys5">
              🏆 Sistema de definición inteligente
            </p>
            <h2 id="tomos-title" className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-278" data-mp="1b9svzmkzt19r">
              MegaPack Definición Inteligente
            </h2>
            <p className="mt-4 text-lg font-bold text-gold" data-id="element-279" data-mp="2qoqor4pfdf26">
              6 Tomos + 5 Bonos — Todos los niveles
            </p>
            <p className="mt-2 text-sm text-neutral-400" data-id="element-280" data-mp="2mnyeq98qb64u">
              168 páginas — Todo resuelto.
            </p>
            <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-281" data-mp="2hlpldbry2227">
              {tomos.map(tomo => <li key={tomo.id} className="rounded-full border border-line bg-ink px-3.5 py-1.5 text-xs font-bold text-neutral-400" data-id="element-282" data-mp="27pcq49gr3g5c">
                  {tomo.emoji} {tomo.label}
                </li>)}
            </ul>
          </div>
          <img src={productMockupUrl} alt="Contenido completo del MegaPack Definición Inteligente: 6 tomos y 5 herramientas bonus" className="mx-auto w-full max-w-lg drop-shadow-[0_25px_50px_rgba(245,197,66,0.16)]" width={1024} height={1024} loading="lazy" data-id="element-283" data-mp="1txy9g9abfr1g" />
        </div>

        <div className="mt-16" data-id="element-284" data-mp="1aal8ssy4fgn4">
          <SectionHeading eyebrow="📚 6 Tomos completos" title="De la filosofía al plan de 8 semanas" data-id="element-285" data-mp="1aeitvk49ei9n" />
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-286" data-mp="11cjcurt8ve6p">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="group relative flex flex-col overflow-hidden rounded-2xl border border-line bg-surface p-6 transition-colors duration-150 ease-out hover:border-gold/50" data-id="element-287" data-mp="15dldnd2t7yas" data-mpi={index}>
              <span className="absolute right-4 top-1 text-6xl font-extrabold text-white/[0.05] transition-colors duration-150 ease-out group-hover:text-gold/15" aria-hidden="true" data-id="element-288" data-mp="2gs025e5atn4f">
                {tomo.id}
              </span>
              <p className="relative text-xs font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-289" data-mp="cc260b4a7pz">
                {tomo.emoji} {tomo.label}
              </p>
              <h3 className="relative mt-2 text-xl font-extrabold leading-tight tracking-tight text-white sm:text-2xl" data-id="element-290" data-mp="a5arxlico4b6">
                {tomo.title}
              </h3>
              <p className="relative mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-291" data-mp="3dl82vwoc5gak">
                {tomo.description}
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-line bg-surface p-6 sm:p-8" data-id="element-292" data-mp="3niw2p10stdzl">
          <h3 className="text-lg font-extrabold tracking-tight text-white" data-id="element-293" data-mp="3nl8q3tpbsgk1">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-294" data-mp="12sx2xetwqb82">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-295" data-mp="38hh17lefqefj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-296" data-mp="38jaa77citaqp" />
                <span className="text-sm text-neutral-300" data-id="element-297" data-mp="3hhcfhz3aepjs">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}